import { omit } from 'lodash-es';
import { DOWNLOAD_CFG_KEY } from '@intelligence/v3/constants';
import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import MobileOverlapTopChartsService from '@intelligence/pages/OverlapAnalysis/MobileGames/adapter';
import { getDateRangeFileName } from '../utils';

/**
 * 获取指定的下载设置
 * @param pageFieldKey 页面参数键
 * @param downloadFormFieldKey 下载表单中参数键
 * @param params 指定得下载设置
 */
const getDownloadFieldListValue = (
  pageFieldKey: string,
  downloadFormFieldKey: string,
  params?: IRecord | null,
): string[] => {
  const downloadFormFieldValue = params?.[downloadFormFieldKey] || [];

  if (Array.isArray(downloadFormFieldValue) && downloadFormFieldValue.length > 0) {
    return downloadFormFieldValue;
  }

  return params?.[pageFieldKey] || [];
};

/**
 * 获取下载日期设置
 * @param params 参数对象
 * @return 下载日期
 */
const getDownloadDateRange = (params?: IRecord | null): IDateRangeFetchParams => {
  const dateType = params?.date_type || 'monthly';
  const startDate = params?.start_date || '';
  const endDate = params?.end_date || '';
  const downloadStartDate = params?.download_start_date || '';
  const downloadEndDate = params?.download_end_date || '';

  return {
    granularity: dateType,
    start_date: downloadStartDate || startDate,
    end_date: downloadEndDate || endDate,
  };
};

const getDownloadApiParams = (params?: IRecord | null): IMetricDataGamesFetchParams => {
  if (!params) return {} as unknown as IMetricDataGamesFetchParams;

  const metrics = getDownloadFieldListValue('metrics', 'download_metrics', params);
  const markets = getDownloadFieldListValue('markets', 'download_markets', params);
  const dateRange = getDownloadDateRange(params);
  const fetchParams = MobileOverlapTopChartsService.convertFetchParams(params);

  const groupBys = ['market', 'date'];

  const orderBys = (() => {
    const metricOrderBy = fetchParams?.order_by?.[0] || '';
    const downloadGroupBys = groupBys.map((groupBy) => `${groupBy} desc`);
    return [...downloadGroupBys, metricOrderBy];
  })();

  return {
    ...omit(fetchParams, ['backup_order_by', 'keyword']),
    ...dateRange,
    metrics,
    markets,
    group_by: groupBys,
    order_by: orderBys,
    page_size: params?.[DOWNLOAD_CFG_KEY.SELECT_TOP],
    top_size: 9999,
    use_custom_fields: [
      'entity_name',
      'publisher',
      'publisher_country_abbre',
      'publisher_country_name_en',
      'parent_publisher',
      'genre',
      'sub_genre',
      'iegg_genre',
      'iegg_sub_genre',
      'sensortower_genre',
      'sensortower_sub_genre',
      'is_special_release_time',
      'release_time',
      'release_time_en',
      'release_time_cn',
      'sensortower_tag',
    ],
  };
};

export default (params?: IRecord | null) => {
  return {
    ...commonSetting,
    downloadMode: 'commonConf',
    downloadConfigKey: 'mobileOverlapTopCharts',
    downloadFetchApi: '/api/v1/intelligence_pc/mobile/metrics',
    downloadApiParams: getDownloadApiParams(params),
    isUsingNewMethod: false,
    fetchOnlyOnce: true,
    dataKey: undefined,
    $$fileName: getDateRangeFileName(params),
    regionOptions: params?.regionOptions,
  };
};
